import React from 'react';
import {useAgentContent} from './use-agent-content';
import UserDataSection from './components/user-data-section';
import RankingSection from './components/ranking-section';

const AgentContent: React.FC = () => {
  const {agentInfo, chart, earningsList, loading} = useAgentContent();

  return (
    <div className="flex-1 p-3 flex flex-col gap-y-3 overflow-y-auto">
      <UserDataSection agentInfo={agentInfo} />
      <RankingSection
        earningsList={earningsList}
        chart={chart}
        loading={loading}
      />
    </div>
  );
};

export default AgentContent;
